'use strict';


export default function ($log, incidents) {
  'ngInject';

  return {
    controller: function () { },
    controllerAs: '$active',
    link: {
      pre: preLink,
    },
    scope: true,
  };

  function preLink(scope, element, attrs, $active) {
    element.addClass('loading');
    $active.limitTo = 20;
    $active.$ready = incidents.getActive($active).finally(function () {
      element.removeClass('loading');
    });
  }
}
